import React from "react";

function Team() {
    return (
        <div className="container">
            <div className="row">
                <h1 className="fs-2 text-center text-muted">People</h1>
            </div>

            <div className="row p-5 text-muted fs-5" style={{lineHeight:"1.8",fontSize:"1.2em"}}>
                <div className="col-6 p-5 text-center">
                    <img src="media/nithinKamath.jpg" alt="nithin" style={{borderRadius:"100%", width:"60%"}}/>
                    <h4 className="mt-3">Adarsh Kumar</h4>
                    <h5 className="mt-3">founder,CEO</h5>
                </div>
                <div className="col-6 p-5">
                    <p>Adarsh bootstrapped and founded Zerodha in 2010 to overcome the hurdles he faced during his decade long stint as a trader. Today, Zerodha has changed the landscape of the Indian broking industry.</p>

                    <p>He is a member of the SEBI Secondary Market Advisory Committee (SMAC) and the Market Data Advisory Committee (MDAC).</p>

                    <p>Playing basketball is his zen.</p>

                    <p> Connect on <a href="#" style={{ textDecoration: "none" }}>Homepage </a>/ <a href="#" style={{ textDecoration: "none" }}>TradingQnA</a> / <a href="#" style={{ textDecoration: "none" }}>Twitter</a></p>
                </div>

            </div>
        </div>

    );
}

export default Team;